import { useState } from "react";
import { SectionHead } from "./SectionHead";
import { ProjectCard } from "./ProjectCard";
import { railTrack, railItem, SwipeHint, useCap, ShowAll } from "./Rail";

const FILTERS = [["all", "All"], ["art", "Art"], ["vignette", "Vignettes"], ["animation", "Animation"]];

export const Projects = ({ index, projects, loading, shape }) => {
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? projects : projects.filter((p) => p.category === filter);
  const cap = useCap(list.length, 6);

  return (
    <section id="works" data-testid="works-section" className="relative px-5 sm:px-10 lg:px-16 pt-20 pb-16 md:pt-28 md:pb-24">
      <SectionHead index={index} kicker="WORKS" title={<>Selected<br /><span className="text-stroke">Files</span></>}>
        <div className="flex flex-wrap gap-2">
          {FILTERS.map(([key, label]) => (
            <button key={key} data-testid={`filter-${key}`} onClick={() => setFilter(key)}
              className={`clip-tab font-mono text-xs uppercase tracking-[0.2em] px-4 py-2.5 transition-colors ${filter === key ? "bg-[#F5A524] text-black" : "bg-[#12131A] text-zinc-300 hover:text-[#F5A524] border border-[#F5A524]/20"}`}>
              {label}
              <span className="ml-2 opacity-60">{key === "all" ? projects.length : projects.filter((p) => p.category === key).length}</span>
            </button>
          ))}
        </div>
      </SectionHead>

      {loading && <p data-testid="works-loading" className="font-mono text-sm text-zinc-400">LOADING ARCHIVE<span className="blink">_</span></p>}
      {!loading && list.length === 0 && (
        <p data-testid="works-empty" className="font-mono text-sm text-zinc-400 border border-dashed border-[#F5A524]/30 p-10">NO FILES IN THIS SECTOR YET.</p>
      )}
      <SwipeHint count={list.length} testid="works-swipe-hint" />
      <div data-testid="works-masonry" className={`${railTrack} md:grid md:grid-cols-2 xl:grid-cols-3 md:gap-5`}>
        {list.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} shape={shape} className={`${shape === "landscape" ? railItem.replace("w-[80vw] max-w-[340px]", "w-[86vw] max-w-[420px]") : railItem} ${cap.hidden(i)}`} />
        ))}
      </div>
      <ShowAll cap={cap} total={list.length} testid="works-show-all" anchor="works" />
    </section>
  );
};
